
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategy/km3_us",
      function () {
        return require("private-next-pages/strategy/km3_us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategy/km3_us"])
      });
    }
  